import { Component } from '@angular/core';

@Component({
  selector: 'vias-contractor-layout',
  templateUrl: './contractor-layout.component.html',
  styleUrls: ['./contractor-layout.component.scss']
})
export class ContractorLayoutComponent {}
